var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6a7 7 0 107 7 7.008 7.008 0 00-7-7zm0 13a6 6 0 116-6 6.006 6.006 0 01-6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.793V8.5a.5.5 0 00-1 0V13a.505.505 0 00.147.354l2.5 2.5a.5.5 0 00.707-.707L13.5 12.793z"
  }))));
}

export default SvgClock;